// PROD
const baseUrl = "https://dms.nablasol.net";

// DEV
// const baseUrl = "https://dms.nablasol.net";

export default baseUrl;
